import { useHerdControlAnalytics } from "features/shared/hooks/useHerdControlAnalytics";
import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as actions from "redux/actions";
import { deveExibirConciliacao } from "../../shared/utils";
import * as ConciliacaoOperations from "../redux/conciliacaoOperations";
import ConciliationPage from "./conciliationPage";

export const ConciliationContainer = (props) => {
  const {
    idFazendaSelecionada,
    obterConciliacoes,
    conciliacoesFazenda,
    obterDetalhesCategoria,
    loading,
    operacoesCategoria,
    dataInicioConciliacao,
    exibirConciliacao,
    fazenda,
  } = props;

  const { trackEvent } = useHerdControlAnalytics({
    tabName: "Conciliação",
  });

  useEffect(() => {
    trackEvent();

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ConciliationPage
      categoryOperations={operacoesCategoria}
      conciliationStartDate={dataInicioConciliacao}
      farm={fazenda}
      farmConciliationData={conciliacoesFazenda}
      getCategoryOperations={obterDetalhesCategoria}
      getConciliationData={obterConciliacoes}
      selectedFarmId={idFazendaSelecionada}
      setLoading={loading}
      showConciliation={exibirConciliacao}
    />
  );
};

const mapStateToProps = (state) => {
  var exibirConciliacao = deveExibirConciliacao(state);
  return {
    fazenda: state.fazenda,
    dataInicioConciliacao: state.fazenda.DataInicioConciliacao,
    conciliacoesFazenda: state.conciliacao.Conciliacoes,
    operacoesCategoria: state.conciliacao.OperacoesCategoria,
    exibirConciliacao: exibirConciliacao,
  };
};

const mapDispatchToProps = {
  obterConciliacoes: ConciliacaoOperations.obterConciliacoes,
  obterDetalhesCategoria: ConciliacaoOperations.obterDetalhesCategoria,
  loading: actions.exibirCarregandoSalvando,
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConciliationContainer);
